interface Client {
  id?: number;
  code?: string;
  taxPayerId?: number;
  isTaxPayer?: boolean;
  ruc?: string;
  socialName?: string;
  fantasyName?: string;
  type?: string;
  countryCode?: string;
  address?: string;
  houseNumber?: number;
  department?: number;
  departmentDescription?: string;
  district?: number;
  districtDescription?: string;
  city?: number;
  cityDescription?: string;
  phoneNumber?: string;
  email?: string;
  hasAddress?: boolean;
}

/** Client details stored on an electronic document even without a client row. */
export interface DocumentClientFields {
  clientId?: number | null;
  taxPayerId?: number | null;
  clientCode?: string | null;
  clientIsTaxPayer?: boolean | null;
  clientRuc?: string | null;
  clientDocumentNumber?: string | null;
  clientSocialName?: string | null;
  clientFantasyName?: string | null;
  clientType?: string | null;
  clientCountryCode?: string | null;
  clientHasAddress?: boolean | null;
  clientAddress?: string | null;
  clientHouseNumber?: number | null;
  clientDepartment?: number | null;
  clientDepartmentDescription?: string | null;
  clientDistrict?: number | null;
  clientDistrictDescription?: string | null;
  clientCity?: number | null;
  clientCityDescription?: string | null;
  clientPhoneNumber?: string | null;
  clientEmail?: string | null;
}

export const clientFromDocument = (document: DocumentClientFields): Client | null => {
  const hasDetails = [
    document.clientCode,
    document.clientRuc,
    document.clientDocumentNumber,
    document.clientSocialName,
    document.clientFantasyName,
    document.clientType,
    document.clientCountryCode,
    document.clientAddress,
    document.clientDepartmentDescription,
    document.clientDistrictDescription,
    document.clientCityDescription,
    document.clientPhoneNumber,
    document.clientEmail,
    document.clientHouseNumber,
    document.clientDepartment,
    document.clientDistrict,
    document.clientCity,
    document.clientHasAddress === true,
  ].some((value) =>
    typeof value === "string" ? value.trim() !== "" : value != null && value !== false
  );

  if (!hasDetails) return null;

  return {
    taxPayerId: document.taxPayerId ?? undefined,
    code: document.clientCode ?? undefined,
    isTaxPayer: document.clientIsTaxPayer ?? undefined,
    ruc: document.clientRuc || document.clientDocumentNumber || undefined,
    socialName: document.clientSocialName ?? undefined,
    fantasyName: document.clientFantasyName ?? undefined,
    type: document.clientType ?? undefined,
    countryCode: document.clientCountryCode ?? undefined,
    hasAddress: document.clientHasAddress ?? undefined,
    address: document.clientAddress ?? undefined,
    houseNumber: document.clientHouseNumber ?? undefined,
    department: document.clientDepartment ?? undefined,
    departmentDescription: document.clientDepartmentDescription ?? undefined,
    district: document.clientDistrict ?? undefined,
    districtDescription: document.clientDistrictDescription ?? undefined,
    city: document.clientCity ?? undefined,
    cityDescription: document.clientCityDescription ?? undefined,
    phoneNumber: document.clientPhoneNumber ?? undefined,
    email: document.clientEmail ?? undefined,
  };
};

// Client types
export const CLIENT_TYPE_PERSON = "person";
export const CLIENT_TYPE_PERSON_LABEL = "Persona";
export const CLIENT_TYPE_ENTITY = "entity";
export const CLIENT_TYPE_ENTITY_LABEL = "Entidad";
export const CLIENT_TYPE_FOREIGN_ENTITY = "foreign_entity";
export const CLIENT_TYPE_FOREIGN_ENTITY_LABEL = "Cliente Extranjero";
export const CLIENT_TYPE_NOT_NOMINATED = "not_nominated";
export const CLIENT_TYPE_NOT_NOMINATED_LABEL = "Sin Nombre";
export const CLIENT_TYPE_DIPLOMATIC = "diplomatic";
export const CLIENT_TYPE_DIPLOMATIC_LABEL = "Diplomático";
export const CLIENT_TYPE_GOVERNMENT = "government";
export const CLIENT_TYPE_GOVERNMENT_LABEL = "Gobierno";

export const CLIENT_TYPE_CHOICES: Map<string, string> = new Map([
  [CLIENT_TYPE_PERSON, CLIENT_TYPE_PERSON_LABEL],
  [CLIENT_TYPE_ENTITY, CLIENT_TYPE_ENTITY_LABEL],
  [CLIENT_TYPE_FOREIGN_ENTITY, CLIENT_TYPE_FOREIGN_ENTITY_LABEL],
  [CLIENT_TYPE_NOT_NOMINATED, CLIENT_TYPE_NOT_NOMINATED_LABEL],
  [CLIENT_TYPE_DIPLOMATIC, CLIENT_TYPE_DIPLOMATIC_LABEL],
  [CLIENT_TYPE_GOVERNMENT, CLIENT_TYPE_GOVERNMENT_LABEL],
]);

export const newClient = (taxPayerId?: number): Client => {
  return {
    taxPayerId: taxPayerId,
  };
};

export default Client;
